import React, { useRef, useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Paper,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import StepMenuShopify from "./StepMenuShopify";
import imagen1 from "../../assets/guias_implementacion/Shopify/1.png"
import imagen2 from "../../assets/guias_implementacion/Shopify/2.png"
import imagen3 from "../../assets/guias_implementacion/Shopify/3.png"
import imagen4 from "../../assets/guias_implementacion/Shopify/4.png"
import imagen5 from "../../assets/guias_implementacion/Shopify/5.png"
import imagen6 from "../../assets/guias_implementacion/Shopify/6.png"
import imagen7 from "../../assets/guias_implementacion/Shopify/7.png"
import imagen8 from "../../assets/guias_implementacion/Shopify/8.png"
import imagen9 from "../../assets/guias_implementacion/Shopify/9.png"
import imagen10 from "../../assets/guias_implementacion/Shopify/10.png"
import imagen11 from "../../assets/guias_implementacion/Shopify/11.png"
import imagen12 from "../../assets/guias_implementacion/Shopify/12.png"
import GuiaHeader from "./GuiaHeader";

const GuiaShopify = () => {
    const ignoreScroll = useRef(false);
    const scrollTimeoutRef = useRef(null);

    const introduccionRef = useRef(null);
    const paso1Ref = useRef(null);
    const paso2Ref = useRef(null);
    const paso3Ref = useRef(null);
    const paso4Ref = useRef(null);
    const paso5Ref = useRef(null);
    const paso6Ref = useRef(null);
    const paso7Ref = useRef(null);
    const paso8Ref = useRef(null);
    const paso9Ref = useRef(null);
    const paso10Ref = useRef(null);
    const paso11Ref = useRef(null);
    const paso12Ref = useRef(null);

    /* eslint-disable */
    const pasoRefs = [
        introduccionRef,
        paso1Ref,
        paso2Ref,
        paso3Ref,
        paso4Ref,
        paso5Ref,
        paso6Ref,
        paso7Ref,
        paso8Ref,
        paso9Ref,
        paso10Ref,
        paso11Ref,
        paso12Ref
    ];

    const [pasoActivo, setPasoActivo] = useState("Introducción");

    const codeString = `<script>
  window.onload = function () {
    const bmvScript = document.createElement('script');
    bmvScript.src = 'https://widget.bemyvega.com/build/bmvPlugin.js';
    bmvScript.addEventListener('load', () => {
      const settings = {};
      BmvPlugin.setConfig(settings);
    });
    document.head.appendChild(bmvScript);
  };
</script>`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(codeString);
    };

    const handleScrollTo = (index) => {
        ignoreScroll.current = true;

        // Cancelar cualquier timeout anterior
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        // Iniciar nuevo scroll
        const targetRef = pasoRefs[index];
        targetRef.current?.scrollIntoView({ behavior: "smooth" });

        // Esperar antes de volver a activar el scroll listener
        scrollTimeoutRef.current = setTimeout(() => {
            ignoreScroll.current = false;
        }, 800); // Puedes ajustar este tiempo si lo ves necesario
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const handleScroll = () => {
            if (ignoreScroll.current) return;
            for (let i = pasoRefs.length - 1; i >= 0; i--) {
                const ref = pasoRefs[i].current;
                if (ref) {
                    const rect = ref.getBoundingClientRect();
                    if (rect.top <= 250) {
                        const nuevoPaso = i === 0 ? "Introducción" : `Paso ${i}`;
                        setPasoActivo(nuevoPaso);
                        break;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

    /*
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    */


    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", p: 4, pb: 0, mr: { xs: -1 }, pr: { xs: 0 } }}>
            <GuiaHeader plataforma="Shopify" />

            <Box sx={{ display: "flex", marginTop: { xs: 10, md: 10 }, alignItems: "flex-start", ml: { xs: -6, md: 0 } }}>
                <Box sx={{ mt: -0.3, display: { xs: 'none', md: 'block' } }}>
                    <StepMenuShopify handleScrollTo={handleScrollTo} pasoActivo={pasoActivo} setPasoActivo={setPasoActivo} />
                </Box>

                <Box sx={{ display: "flex", flexGrow: 1, paddingLeft: { xs: 0, md: 28 }, flexDirection: 'column' }}>
                    <Box sx={{ flexGrow: 1, paddingLeft: 4.26, position: "relative" }}>
                        {/* Barra vertical dentro del contenido */}
                        <Box
                            sx={{
                                position: "absolute",
                                width: "4px",
                                height: "100%",
                                backgroundColor: "rgb(162, 182, 212)",
                                left: 0,
                                top: 10,
                                display: { xs: 'none', md: 'block' }
                            }}
                        />
                        {/* Introducción */}
                        <Box sx={{ position: "relative", paddingLeft: 0 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={introduccionRef} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Introducción
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1 }}>
                                    A lo largo del siguiente documento se expondrá el proceso de implementación, paso a paso, que se debe seguir para implementar la solución de accesibilidad digital de Viewser en una Web hecha con el CMS <b>Shopify. </b>
                                    Recuerde que previamente debe tener una cuenta registrada y haber contratado la solución desde <a href="https://dash.bemyvega.com/login">nuestro portal de clientes</a> asociando el dominio de la web en donde implementará nuestra solución.
                                    La implementación de la solución es tan sencilla como introducir este código desde el portal de administración de su Web en Shopify
                                </Typography>
                                <Paper
                                    sx={{
                                        padding: 2,
                                        marginTop: 2,
                                        position: "relative",
                                        boxShadow: "0px 0px 24px 2px rgba(0, 0, 0, 0.2)",
                                        overflowX: "auto",
                                        maxWidth: "100%",
                                        whiteSpace: "pre-wrap", // opcional para mantener saltos de línea
                                        wordBreak: "break-word", // rompe palabras largas
                                    }}
                                >

                                    <Typography component="pre" sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                                        {codeString}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ position: "absolute", top: { xs: 4, md: 8 }, right: { xs: 4, md: 8 } }}
                                        onClick={copyToClipboard}
                                        startIcon={<ContentCopyIcon />}
                                    >
                                        Copiar
                                    </Button>
                                </Paper>
                                <Typography variant="body1" sx={{ marginTop: 2, mb: 6.5 }}>
                                    Tenga a mano este código, ya que lo usaremos en el último paso de la guía.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Paso 1 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso1Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 1
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Para acceder al portal de administración de su web,</b> diríjase a la web de <a href="www.shopify.com">www.shopify.com</a> y clicke el botón de iniciar sesión.
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen1}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Paso 2 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso2Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 2
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Introducir las credenciales de acceso de su cuenta de Clientify,</b> en caso de no conocerlas, debe pedirlas a la persona encargada de gestionar su sitio web:
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen2}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    Puede continuar con su cuenta de Apple, Facebook o Google en el caso de tenerlo configurado de esta forma.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Paso 3 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso3Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 3
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    Una vez haya iniciado sesión, se encontrara en el portal de administración de su web en Shopify, en dicho portal, <b>en la barra de navegación izquierda,</b> deberá clickar en la opción <b>“Tienda online”</b>
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen3}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Paso 4 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso4Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 4
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    Se le desplegará el siguiente submenú, y <b>asegúrese de encontrarse en</b> el apartado <b>“Temas”</b>
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen4}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Paso 5 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso5Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 5
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Pulse sobre</b> el icono de los 3 puntitos <b>[⋯]</b> y <b>clicke la opción “Duplicar”,</b> esto creará una copia de seguridad de su tema.
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen5}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Paso 6 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso6Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 6
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Vuelva a pulsar sobre</b> el icono de los 3 puntitos <b>[⋯]</b> y <b>clicke “Editar código”,</b> esto creará una copia de seguridad de su tema.
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen6}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    Se le mostrará una lista de archivos de su plantilla o tema (Siguiente paso)
                                </Typography>
                            </Box>
                        </Box>

                        {/* Paso 7 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso7Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 7
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Dentro de la lista de archivos de su tema,</b> pulse sobre el apartado llamado <b>“theme.liquid”,</b> se le mostrará este archivo en la parte derecha de la pantalla.
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen7} 
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Paso 8 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso8Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 8
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Vuelva a pulsar sobre</b> el icono de los 3 puntitos <b>[⋯]</b> y <b>clicke “Editar código”,</b> esto creará una copia de seguridad de su tema.
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen8} 
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    Se le mostrará una lista de archivos de su plantilla o tema (Siguiente paso)
                                </Typography>
                            </Box>
                        </Box>

                        {/* Paso 9 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso9Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 9
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Dentro de la lista de archivos de su tema,</b> pulse sobre el apartado llamado <b>“theme.liquid”,</b> se le mostrará este archivo en la parte derecha de la pantalla.
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen9} 
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Paso 10 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso10Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 10
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    <b>Baje hasta el final del archivo</b> donde encontrará una línea de código en la que pone <b>&lt;/body&gt;,</b> presione <b>[ Enter ⏎ ]</b> varias veces antes de esta línea de código (<b>&lt;/body&gt;</b>) para dejar espacio para el código del widget.
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen10} 
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" },
                                    }}
                                />
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                Es aquí donde deberá pegar el código proporcionado al inicio de este documento.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Paso 11 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso11Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 11
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                <b>Una vez pegado el fragmento de código</b> que le hemos proporcionado (color más oscuro), <b>clicke sobre el botón guardar</b>
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen11} 
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Paso 12 */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: -2 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={paso12Ref} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Paso 12
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                <b>¡Listo!</b> Ha completado con éxito la implementación, puede previsualizar el widget y sus funcionalidades clicando sobre <b>“Obtener vista previa de la tienda”.</b>
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen12}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "1047px" }, // Se adapta en móviles
                                    }}
                                />
                                <Typography variant="body1" sx={{ marginTop: 1 }}>
                                El botón de abrir el widget aparecerá en la esquina inferior derecha de su tienda online.
                                </Typography>
                            </Box>
                        </Box>


                    </Box>

                    {/* Contacto */}
                    <Box ml={2.5}>
                        <Typography variant="body1" sx={{ marginTop: 10 }}>
                            <strong>Puede contactarnos</strong> mediante cualquiera de las vías que se ofrecen a continuación, contestaremos con la mayor brevedad posible.
                        </Typography>
                        <List sx={{ paddingLeft: 2 }}>
                            <ListItem disablePadding>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 10, color: "#0F52BD" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <span>
                                            Email: <Link href="mailto:hola@bemyvega.com">hola@bemyvega.com</Link>
                                        </span>
                                    }
                                />
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 10, color: "#0F52BD" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <span>
                                            Web: <Link href="https://www.goviewser.com/contacto" target="_blank" rel="noopener">www.goviewser.com/contacto</Link>
                                        </span>
                                    }
                                />
                            </ListItem>
                        </List>
                        <Typography variant="body1">
                            <strong>Muchas gracias por confiar en nosotros</strong>, estaremos encantados de solucionar cualquier duda que le surja durante el proceso de implementación.
                        </Typography>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
};

export default GuiaShopify;